/* src/store.js
   Zentrale Redux-Store-Konfiguration (Minimal-Setup für die App).
   Kann später um Slices/Reducer erweitert werden. */

import { configureStore } from "@reduxjs/toolkit";

// Platzhalter-Reducer-Objekt – hier später deine Slices eintragen, z. B. auth, cv, ui, ...
export const store = configureStore({
  reducer: {},
  // optional: weitere Optionen
  devTools: process.env.NODE_ENV !== "production",
});
